import { LocaleType } from './Locale';

const theLocale: LocaleType = {
    locale: 'nl',
    conver: 'nl-NL',
    alia: 'nl',
    region: 'Netherlands',
    regionText: 'Nederland',
    language: 'Dutch',
    languageText: 'Nederlands',
    appId: 14,
    acceptLanguage: 'nl-NL,nl;q=0.9',
};
export default theLocale;
